import { Pipe, PipeTransform } from '@angular/core';

export function sortClasses(classes: string[]): string[] {
    const backgroundClassName = 'background';
    const sortedClasses = new Array<string>();

    // add background class as first item and add the remaining classes sorted alphabetically ascending
    if (classes.includes(backgroundClassName)) {
        sortedClasses.push(backgroundClassName);
    }
    sortedClasses.push(...(classes.filter((className: string) => className !== backgroundClassName).sort() || []));

    return sortedClasses;
}

@Pipe({ name: 'sortClasses' })
export class SortClassesPipe implements PipeTransform {
    transform(classes: string[]): string[] {
        return sortClasses(classes);
    }
}
